module.exports = __webpack_public_path__ + "static/media/slider2400960_holyrelic-2.a407aad7.jpg";